import React from 'react';
import HeaderModules from '../HeaderModules';
import { DehazeOutlined } from '@material-ui/icons';

const TarifasScreen = () => {

    return (
        <HeaderModules 
            icon={<DehazeOutlined htmlColor='rgba(0,0,0, .7)' />} 
            title='Tarifas' 
        />
    );
}

export default TarifasScreen;